export class InvalidRoleError extends Error {
  constructor(msg: string = 'InvalidRoleError!') {
    super(msg);
    // see: https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html
    Object.setPrototypeOf(this, new.target.prototype); // restore prototype chain
    this.name = InvalidRoleError.name; // stack traces display correctly now
  }
}
